import { ApiError, isQueryTimeout } from "./apiError";

const MAX_RETRIES = 3;

const statusOf = (error: unknown): number | undefined => {
  if (error instanceof ApiError) {
    return error.status;
  }
  if (typeof error !== "object" || error === null) {
    return undefined;
  }
  if ("http_status" in error && typeof error.http_status === "number") {
    return error.http_status;
  }
  if ("statusCode" in error && typeof error.statusCode === "number") {
    return error.statusCode;
  }
  return undefined;
};

const isClientError = (error: unknown): boolean => {
  const status = statusOf(error);
  return status !== undefined && status >= 400 && status < 500;
};

export const shouldRetryQuery = (failureCount: number, error: unknown) =>
  failureCount < MAX_RETRIES && !isQueryTimeout(error) && !isClientError(error);
